module.exports = __webpack_public_path__ + "assets/img/btn-pic.d75cd9d0.png";